import styled from 'styled-components';
import { PrimaryButton, PrimaryAltButton, ButtonContainer } from './Buttons';

const LoginFormHeader = styled.div`
  margin-bottom: 30px;
`;

const LoginFormFooter = styled(ButtonContainer)`
  margin-top: 40px;
`;

const LoginAgainFormButton = styled(PrimaryAltButton)`
  width: 100%;
`;

const LoginFormButton = styled(PrimaryButton)`
  width: 100%;

  + ${LoginAgainFormButton} {
    margin-top: 20px;
  }
`;

export {
  LoginFormHeader,
  LoginFormFooter,
  LoginFormButton,
  LoginAgainFormButton
};
